import { Account } from '@/domain/usecases'
import { Partner } from '@/domain/models/partner/partner-model'
import { PartnerDescription as PartnerDescriptionModel } from '@/domain/models/partner/partner-description-model'
import { PartnerDetail } from '@/domain/usecases/partner/partner-detail'
import { PartnerDescription } from '@/domain/usecases/partner/partner-description'
import { QueryClient } from 'react-query'
import { LoaderFunctionArgs, defer } from 'react-router-dom'
import InternalCompanyManagerBaseLoader from '../internal-company-manager/internal-company-manager-base-loader'

export type PartnerDetailLoadDataType = {
  partner: Partner.Model
  description: PartnerDescriptionModel.Model[]
}

export default class PartnerDetailLoader extends InternalCompanyManagerBaseLoader {
  private static readonly ID_PATH_PARAM_NAME = 'id'

  constructor(
    readonly account: Account.Model,
    readonly queryClient: QueryClient
  ) {
    super(account, queryClient)
  }

  async loader({ params }: LoaderFunctionArgs) {
    const id = params[PartnerDetailLoader.ID_PATH_PARAM_NAME] ?? ''

    return defer({
      data: Promise.all([
        super.importRemoteModule('makeRemotePartnerDetail').then(async makeRemote => {
          const remotePartnerDetail = makeRemote(this.queryClient) as PartnerDetail
          return remotePartnerDetail.get(id)
        }),
        super.importRemoteModule('makeRemotePartnerDescription').then(async makeRemote => {
          const remotePartnerDescription = makeRemote(this.queryClient) as PartnerDescription
          return remotePartnerDescription.get(id)
        })
      ]).then(([partner, description]) => ({
        partner,
        description
      }))
    })
  }
}
